@if (common.offer && utility.show) {
  <div style="text-align: center;" class="alert alert-primary mb-0 pt-1 pb-1">Available offer {{ +common.offer.percentage | number:'1.0-3' }}%</div>
}
<div class="font">
  @if (this.utility.show) {
    <nav class="navbar navbar-expand-lg navbar-light" style="background-color: #431a2a;">
      <div class="container-fluid">
        <a class="navbar-brand font" style="color: white; font-size: 14;">
          PHYSIO LIFE
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor03"
          aria-controls="navbarColor03" aria-expanded="false" aria-label="Toggle navigation">
          <span style="background-color:#431a2a; font-size: 14;" class="navbar-dark navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarColor03">
          <ul class="navbar-nav mb-2 mb-lg-0 me-auto">
            @if (this.api.canEnter(['admin', 'staff', 'accountant'])) {
              <li class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link" [routerLink]="['/home']">Home</a>
              </li>
            }
            @if (this.api.canEnter(['doctor'])) {
              <li class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link" [routerLink]="['/doctorHomePage']">Home</a>
              </li>
            }
            <li class="nav-item" [routerLinkActive]="['active']">
              <a class="nav-link" [routerLink]="['/appointments']">Appointments</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['active']">
              <a class="nav-link" [routerLink]="['/patients']">Patients</a>
            </li>
            @if (this.api.canEnter(['admin', 'staff', 'accountant'])) {
              <li class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link" [routerLink]="['/doctors']">Clinicians</a>
              </li>
            }
            <li class="nav-item" [routerLinkActive]="['active']">
              <a class="nav-link" [routerLink]="['/store']">eStore</a>
            </li>
          </ul>
          <ul class="navbar-nav ms-auto">
            <!-- <li class="nav-item" [routerLinkActive]="['active']">
            <a class="nav-link" [routerLink]="['/invoices']">Invoices</a>
          </li> -->
          <li class="nav-item" [routerLinkActive]="['active']">
            <a class="nav-link" [routerLink]="['/profile']">Profile</a>
          </li>
          @if (this.api.canEnter(['admin'])) {
            <li class="nav-item dropdown" [routerLinkActive]="['active']">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                Reports
              </a>
              <ul class="dropdown-menu dropdown-menu-dark dropdown-menu-end" aria-labelledby="navbarDropdown">
                <li><a class="dropdown-item" [routerLink]="['/invoices']">Invoices</a></li>
                <!-- <li><a class="dropdown-item" [routerLink]="['/pending-appointments']">Pending Appointments</a></li> -->
                <li><a class="dropdown-item" [routerLink]="['/reports']">Payment Report</a></li>
                <li><a class="dropdown-item" [routerLink]="['/graph-report']">Graph Report</a></li>
              </ul>
            </li>
          }
          @if (this.api.canEnter(['admin'])) {
            <li class="nav-item dropdown" [routerLinkActive]="['active']">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                Admin Control
              </a>
              <ul class="dropdown-menu dropdown-menu-dark dropdown-menu-end" aria-labelledby="navbarDropdown">
                <li><a class="dropdown-item" [routerLink]="['/users']">Users Management</a></li>
                <li>
                  <hr class="dropdown-divider">
                </li>
                <li><a class="dropdown-item" [routerLink]="['/employees']">Employees Management</a></li>
                <!-- <li><a class="dropdown-item" [routerLink]="['/salary']">Employees Salary</a></li> -->
                <li><a class="dropdown-item" [routerLink]="['/attendance']">Employees Leaves</a></li>
                <li>
                  <hr class="dropdown-divider">
                </li>
                <!-- <li><a class="dropdown-item" [routerLink]="['/reports']">Reports</a></li> -->
                <li>
                  <hr class="dropdown-divider">
                </li>
                <li><a class="dropdown-item" [routerLink]="['/settings']">Services</a></li>
                <li><a class="dropdown-item" [routerLink]="['/packages']">Packages</a></li>
                <li><a class="dropdown-item" [routerLink]="['/user-packages']">Check Patients' Packages</a></li>
                <li><a class="dropdown-item" [routerLink]="['/offers']">Offers</a></li>
                <li>
                  <hr class="dropdown-divider">
                </li>
                <li><a class="dropdown-item" [routerLink]="['/items']">Items Sells</a></li>
              </ul>
            </li>
          }
          <li class="nav-item active">
            <button class="btn btn-secondary" (click)="onLogout()">Logout</button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
}
<router-outlet>
  <br>
    @if (utility.loading) {
      <div class="row">
        <div class="d-flex justify-content-center">
          @if (utility.loading) {
            <div class="medical-loader" role="status" aria-live="polite" aria-label="Loading">
              <svg class="heartbeat-svg" viewBox="0 0 220 44" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <line x1="0" y1="22" x2="220" y2="22" class="heartbeat-track"></line>
                <polyline class="heartbeat-line" points="0,22 60,22 74,22 82,10 92,34 102,12 112,22 130,22 220,22"></polyline>
              </svg>
              <div class="loader-text">Loading...</div>
            </div>
          }
        </div>
      </div>
    }
  </router-outlet>
</div>